import {SET_CLIENTS_ERROR, SET_CLIENTS, SET_CLIENTS_LOADING, SET_CLIENTS_SAVING, SET_CLIENTS_SAVING_ERROR, ADDED_NEW_CLIENT } from 'store/reducers/clientsReducer'
import { snapshotToObjects } from 'util/firestore';
import _ from 'lodash'

const removeEmpty = (obj) => {
    Object.keys(obj).forEach(key => {
        if (obj[key] && typeof obj[key] === 'object') removeEmpty(obj[key]);
        else if (obj[key] === undefined) delete obj[key];
    });
    return obj;
};

export const loadClientList = (userId) => {
    return async (dispatch, getState, { getFirebase, getFirestore }) => {

        const state = getState();
        // const userId = state.user.userData.platformID;

        dispatch({type: SET_CLIENTS_LOADING, isLoading: true})

        const firestore = getFirestore();
        firestore.collection("instructor_dashboards").doc(userId).collection("clients").get()
            .then(snapshot => {
                // TODO set reservations

                var clients = snapshotToObjects(snapshot).filter(val => !val.removed)
                
                dispatch({ type: SET_CLIENTS, clients: clients })
                dispatch({type: SET_CLIENTS_LOADING, isLoading: false})
            })
            .catch( err => {
                console.log("Error getting client data: " + err)
            })
    }
}

export const deleteClient = (data) => {
    return async (dispatch, getState, { getFirebase, getFirestore }) => {

        if (!data.platformID) {
            dispatch({type: SET_CLIENTS_ERROR, error: "Unable to remove this client" })
            return 
        }

        const state = getState();
        const userId = state.user.userData.platformID

        // dispatch({type: SET_CLIENTS_SAVING, isSaving: true })

        const firestore = getFirestore();

        return new Promise(async (resolve, reject) => {

            try {

                await firestore
                    .collection("instructor_dashboards")
                    .doc(userId).collection("clients")
                    .doc(data.platformID).update({
                        removed: true
                    })
                
                // var clients = {...state.clients.clients}
                // console.log(clients)
                // _.remove(clients, val => val.platformID === data.platformID);

                const clients = _.filter(state.clients.clients, function(x) { return x?.platformID !== data?.platformID; });
                // _.reject(state.clients, function(el) {
                //     return el?.platformID === data?.platformID
                //  });

                 console.log(clients)
                // state.clients.filter(function(el) { return el.platformID !== data.platformID; });
                dispatch({ type: SET_CLIENTS, clients: clients })
                

                // data.platformID = newRef.id
                // dispatch({type: ADDED_NEW_CLIENT, newClient: data})
                // dispatch({type: SET_CLIENTS_SAVING, isSaving: false })
                // dispatch({type: SET_CLIENTS_SAVING_ERROR, savingError: null })
                resolve("Done")
            } catch (err) {
                dispatch({type: SET_CLIENTS_ERROR, error: "Unable to remove this client" })
                // dispatch({type: SET_CLIENTS_SAVING, isSaving: false })
                // dispatch({type: SET_CLIENTS_SAVING_ERROR, savingError: "Something went wrong, please try again" })
                reject(err)
                console.log(`Error removing client: ${err}`)
            }
        })
    }
}

export const addNewClient = (data) => {
    return async (dispatch, getState, { getFirebase, getFirestore }) => {

        removeEmpty(data)

        const state = getState();
        const userId = state.user.userData.platformID

        dispatch({type: SET_CLIENTS_SAVING, isSaving: true })

        const firestore = getFirestore();

        return new Promise(async (resolve, reject) => {

            try {

                const newRef = await firestore.collection("instructor_dashboards").doc(userId).collection("clients").add(data)
                data.platformID = newRef.id
                dispatch({type: ADDED_NEW_CLIENT, newClient: data})
                dispatch({type: SET_CLIENTS_SAVING, isSaving: false })
                dispatch({type: SET_CLIENTS_SAVING_ERROR, savingError: null })
                resolve("Done")
            } catch (err) {
                dispatch({type: SET_CLIENTS_SAVING, isSaving: false })
                dispatch({type: SET_CLIENTS_SAVING_ERROR, savingError: "Something went wrong, please try again" })
                reject(err)
                console.log(`Error saving new client: ${err}`)
            }
        })
    }

    
}